import React, { useEffect, useState } from 'react';
import { useForm, Controller } from 'react-hook-form';
import { postRequest } from '../../../../lib/api';
import { useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  OutlinedInput,
  InputAdornment,
  Checkbox,
  FormGroup,
  FormControlLabel,
  Stack,
  Button,
} from '@mui/material';
import BreadcrumbsWrapper from '../../../../components/breadcrumbs';

const AddCustomLeadFee = () => {
  const [productList, setProductList] = useState([]);
  const navigate = useNavigate();

  const {
    control,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      product: '',
      title: '',
      net: '',
      tax_exempt: false,
      is_optional: false,
      isActive: true,
    },
  });

  useEffect(() => {
    const fetchProduct = async () => {
      try {
        const response = await postRequest('private/GetProducts');
        if (response?.data) {
          setProductList(response.data);
        }
      } catch (err) {
        console.error('Failed to fetch products:', err);
      }
    };
    fetchProduct();
  }, []);

  const onSubmit = async (data) => {
    const payload = {
      title: data.title,
      product_id: data.product,
      net: Number(data.net),
      tax_exempt: data.tax_exempt,
      is_optional: data.is_optional,
      isActive: data.isActive,
    };

    try {
      const response = await postRequest('private/customeLeadFeesCreate', payload);
      if (response?.status === 200) {
       // toast.success('Custom Fee Created');
        navigate(-1);
      }
    } catch (error) {
      console.error('Submission failed:', error);
    }
  };

  return (
    <>
      <BreadcrumbsWrapper
        items={[
          { label: 'Dashboard', path: '/dashboard' },
          { label: 'CustomLeadFees', path: '/custom/lead-fees' },
          { label: 'CreateCustomLeadFees', path: '' },
        ]}
      />
      <br />

      <div style={{ padding: '20px' }}>
        <div className='page-header'>
          <h1 className='mt-0'>Add New Custom Lead Fee</h1>
        </div>

        <form onSubmit={handleSubmit(onSubmit)}>
          {/* Product Select */}
          <FormControl fullWidth margin="normal">
            <InputLabel>Product</InputLabel>
            <Controller
              name="product"
              control={control}
              rules={{ required: 'Product is required' }}
              render={({ field }) => (
                <Select {...field} label="Product">
                  {productList.map((product) => (
                    <MenuItem key={product._id} value={product._id}>
                      {product.title}
                    </MenuItem>
                  ))}
                </Select>
              )}
            />
            {errors.product && <span style={{ color: 'red' }}>{errors.product.message}</span>}
          </FormControl>

          {/* Title */}
          <Controller
            name="title"
            control={control}
            rules={{ required: 'Title is required' }}
            render={({ field }) => (
              <TextField {...field} fullWidth label="Title" variant="outlined" margin="normal" />
            )}
          />
          {errors.title && <span style={{ color: 'red' }}>{errors.title.message}</span>}

          {/* Net */}
          <FormControl fullWidth margin="normal">
            <InputLabel>Net</InputLabel>
            <Controller
              name="net"
              control={control}
              rules={{
                required: 'Net amount is required',
                min: { value: 0, message: 'Net must be ≥ 0' },
              }}
              render={({ field }) => (
                <OutlinedInput
                  {...field}
                  type="number"
                  startAdornment={<InputAdornment position="start">£</InputAdornment>}
                  label="Net"
                />
              )}
            />
            {errors.net && <span style={{ color: 'red' }}>{errors.net.message}</span>}
          </FormControl>

          {/* Checkboxes */}
          <FormGroup sx={{ mt: 2 }}>
            <Controller
              name="tax_exempt"
              control={control}
              render={({ field }) => (
                <FormControlLabel control={<Checkbox {...field} checked={field.value} />} label="Tax Exempt? (VAT will not be applied)" />
              )}
            />

            <Controller
              name="is_optional"
              control={control}
              render={({ field }) => (
                <FormControlLabel control={<Checkbox {...field} checked={field.value} />} label="Is Optional" />
              )}
            />

            <Controller
              name="isActive"
              control={control}
              render={({ field }) => (
                <FormControlLabel control={<Checkbox {...field} checked={field.value} />} label="Is Active" />
              )}
            />
          </FormGroup>

          {/* Buttons */}
          <FormControl fullWidth sx={{ mt: 3 }}>
            <Stack spacing={2} direction="row">
              <Button variant="outlined" onClick={() => navigate(-1)} className="red-outline-btn text-capitalize">
                Cancel
              </Button>
              <Button variant="contained" type="submit" className="red-bg red-button text-capitalize h-56">
                Submit
              </Button>
            </Stack>
          </FormControl>
        </form>
      </div>
    </>
  );
};

export default AddCustomLeadFee;
